import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin: 32px 0 32px;
  color: ${ ({ theme }) => theme.colors.black };

  /* The icon sits centred on the text block, however many lines it wraps to. */
  .icon {
    flex-shrink: 0;
    display: block;
    width: 18px;
    height: 18px;
    background-color: ${ ({ theme }) => theme.colors.primary };
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }

  p {
    margin: 0;
    font-size: 13px;
    line-height: 18px;
  }
`
